import { useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from '@tanstack/react-router'
import { PlusSquareIcon } from 'lucide-react'

import { IosShareIcon } from '~/boundedContext/settings/components/ios-share-icon'
import { LinkButton } from '~/components/link-button'
import { useSettingsStore } from '~/stores/settings'
import { isIOS } from '~/utils/is-ios'
import { isSafari } from '~/utils/is-safari'

export const IOSInstallPage = () => {
  const isPageVisible = useMemo(() => isIOS() && isSafari(), [])
  const navigate = useNavigate()
  const { t } = useTranslation()
  const patchSettings = useSettingsStore(state => state.patchSettings)

  useEffect(() => {
    if (!isPageVisible) void navigate({ to: '/list' })
  }, [navigate, isPageVisible])

  if (!isPageVisible) return null

  return (
    <div className="flex h-full w-full flex-col items-center justify-end gap-10">
      <section className="flex flex-col items-center gap-2">
        <h3 className="max-w-xs text-center text-xl">
          {t('Install this application on your home screen for a better experience')}
        </h3>
        <p className="flex items-center gap-3">
          {t('Tap the Share button at the bottom center of the screen')} <IosShareIcon className="fill-[#007AFF]" />
        </p>
        <img alt="ios-safari-share" className="aspect-[9/1] w-full max-w-sm" src="/ios-safari-share.webp" />
        {t('then')}
        <p className="flex items-center gap-3">
          {t('Click on Add to Home Screen option')} <PlusSquareIcon className="stroke-[1.5px]" />
        </p>
        <img
          alt="ios-safari-add-to-home-screen"
          className="aspect-[4/1] w-full max-w-sm"
          src="/ios-safari-add-to-home.webp"
        />
      </section>
      <section className="flex flex-col gap-3">
        <LinkButton
          className="w-[200px]"
          onClick={() => patchSettings({ appWasInstalled: true })}
          to="/list"
          variant="secondary"
        >
          {t('Already installed')}
        </LinkButton>
        <LinkButton className="w-[200px]" to="/settings" variant="outline">
          {t('Back')}
        </LinkButton>
      </section>
    </div>
  )
}
